import { PagedFilter } from "../misc/pagedFilter";
import { ApproversResult, AssignationInfo, AssignationRemoveResult } from "../models/approver.model";
import ServiceBase from "./base.service";

export class ApproversService extends ServiceBase {
  search = async (pagedFilter: PagedFilter): Promise<ApproversResult> =>
    this.get(
      `admin/approvers?pageNumber=${pagedFilter.pageNumber}&pageSize=${pagedFilter.pageSize}&sortField=${pagedFilter.sortField}&sortDescending=${pagedFilter.sortDescending}`
    );

  divisionsActive = async (): Promise<string[]> => this.get(`admin/divisions-active`);

  assign = async (assignationInfo: AssignationInfo): Promise<AssignationInfo> => this.post(`admin/approvers`, assignationInfo);

  assignUpdate = async (assignationInfo: AssignationInfo): Promise<AssignationInfo> => this.put(`admin/approvers`, assignationInfo);

  remove = async (divisionId: number): Promise<AssignationRemoveResult> => this.delete(`admin/approvers/${divisionId}`);
}

const approversService = new ApproversService();

export default approversService;
